import Vue from 'vue';
import './plugins/axios';
import App from './components/App.vue';
import store from './store/gnb';
import '@/assets/scss/style.scss';
import vClickOutside from 'v-click-outside';
import i18n from '@/i18n';
//fort-awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown, faCaretUp, faPlus, faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import visibility from 'vue-visibility-change';

const service = window.location.hostname.split('.')[0];
const gnbApp = document.querySelector('#gnb-app');

if (gnbApp) {
  const tabMenuElement = document.createElement('div');
  tabMenuElement.id = 'tab-menu-root';

  gnbApp.parentNode.insertBefore(tabMenuElement, gnbApp);
}

let styleLevel;

if (gnbApp && gnbApp.attributes['data-style']) {
  styleLevel = gnbApp.attributes['data-style'].value || '';
}

if (styleLevel === 'scoped') {
  console.log('[GNB] applied scopedReset');
  require('./assets/scss/base/scopedReset.scss');
} else if (
  service === 'home' ||
  service === 'hr-work' ||
  service === 'contact' ||
  service === 'team-mail' ||
  service === 'groups' ||
  service === 'officeadmin' ||
  service === 'files' ||
  service === 'plus' ||
  service === 'scheduler' ||
  styleLevel === 'lv1'
) {
  console.log('[GNB] applied hiworksReset');
  require('./assets/scss/base/hiworksReset.scss');
} else {
  console.log('[GNB] applied legacyReset');
  require('./assets/scss/base/legacyReset.scss');
}

Vue.config.productionTip = false;
Vue.use(vClickOutside);
Vue.use(visibility);
library.add(faCaretDown);
library.add(faCaretUp);
library.add(faPlus);
library.add(faPen);
library.add(faTrashAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  render: (h) => h(App),
  store,
  i18n,
  mounted() {
    const script = document.createElement('script');
    script.type = 'application/javascript';
    script.src = `${process.env.VUE_APP_TAB_MENU_PATH}/app.js`;

    script.onerror = () => console.log('not found tab-menu script');
    document.body.appendChild(script);
  },
}).$mount('#gnb-app');
